export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6648.2721007a.jpg";